/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContentType } from '../models/ContentType';
import type { CreateTemplateRequest } from '../models/CreateTemplateRequest';
import type { CreateTemplateResponse } from '../models/CreateTemplateResponse';
import type { GetTemplateResponse } from '../models/GetTemplateResponse';
import type { SearchTemplateResponse } from '../models/SearchTemplateResponse';
import type { UpdateTemplateRequest } from '../models/UpdateTemplateRequest';
import type { UpdateTemplateResponse } from '../models/UpdateTemplateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TemplatesService {
    /**
     * Updates a template
     * This endpoint requires the following permissions: [ Templates.Menu.Create.Templates ]
     * @param id
     * @param requestBody
     * @returns UpdateTemplateResponse Success
     * @throws ApiError
     */
    public static updateSystemTemplateEndpoint(
        id: string,
        requestBody: UpdateTemplateRequest,
    ): CancelablePromise<UpdateTemplateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/system-templates/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get a template by its ID
     * This endpoint requires the following permissions: [ Templates.Menu.View.Templates ]
     * @param id
     * @returns GetTemplateResponse Success
     * @throws ApiError
     */
    public static getSystemTemplateEndpoint(
        id: string,
    ): CancelablePromise<GetTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/system-templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Deletes a template by its ID.
     * This endpoint requires the following permissions: [ Templates.Menu.Delete.Templates ]
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteSystemTemplateEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/system-templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Gets a list of templates with possibility to filter by different parameters.
     * This endpoint requires the following permissions: [ Templates.Menu.View.Templates ]
     * @param pageNumber
     * @param pageSize
     * @param searchTerm
     * @param entityIds
     * @param ids
     * @param institutionIds
     * @param roleIds
     * @param userIds
     * @param isPublic
     * @param type
     * @returns SearchTemplateResponse Success
     * @throws ApiError
     */
    public static getSystemTemplateListEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        entityIds?: Array<string> | null,
        ids?: Array<string> | null,
        institutionIds?: Array<string> | null,
        roleIds?: Array<string> | null,
        userIds?: Array<string> | null,
        isPublic?: boolean | null,
        type?: Array<ContentType> | null,
    ): CancelablePromise<SearchTemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/system-templates',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'entityIds': entityIds,
                'ids': ids,
                'institutionIds': institutionIds,
                'roleIds': roleIds,
                'userIds': userIds,
                'isPublic': isPublic,
                'type': type,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Creates a new template.
     * This endpoint requires the following permissions: [ Templates.Menu.Create.Templates ]
     * @param requestBody
     * @returns CreateTemplateResponse Success
     * @throws ApiError
     */
    public static createSystemTemplateEndpoint(
        requestBody: CreateTemplateRequest,
    ): CancelablePromise<CreateTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/system-templates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
}
